<template>
    <div class="conversation-header">
        <div class="header-left">
            <button v-if="isMobile" @click="$emit('back')" class="back-button">
                <i class="mdi mdi-menu-left"></i>
            </button>

            <div class="header-avatar-wrapper position-relative">
                <div class="header-avatar">
                    <img v-if="contact.picture" :src="storageUrl + contact.picture"
                        :alt="contact.username || contact.firstname" />
                    <span v-else class="avatar-initial">
                        {{ (contact.username || contact.firstname).charAt(0).toUpperCase() }}
                    </span>
                </div>

                <span class="status-bubble-2" :class="contact.is_online ? 'online' : 'offline'"></span>
            </div>

            <div class="header-info">
                <h2>
                    {{ contact.username || (contact.firstname + ' ' + contact.lastname) }}
                    <svg v-if="contact.verified" class="verified-icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clip-rule="evenodd" />
                    </svg>
                </h2>
                <p>{{ contact.last_activity | moment }}</p>
            </div>
        </div>

        <button class="more-button d-none">
            <span class="mdi mdi-dots-vertical"></span>
        </button>
    </div>
</template>

<script>
import config from "@/config";

export default {
    name: "ConversationHeader",
    props: {
        contact: {
            type: Object,
            required: true
        },
        isMobile: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            storageUrl: config.storageUrl
        };
    }
};
</script>

<style scoped>
.mdi {
    font-size: 30pt;
}

.conversation-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid var(--gray-200);
}

.header-left {
    display: flex;
    align-items: center;
}

.back-button {
    background: none;
    border: none;
    padding: 8px;
    margin-right: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.back-icon {
    width: 20px;
    height: 20px;
    color: var(--gray-500);
}

.header-avatar-wrapper {
    position: relative;
    display: inline-block;
}

.header-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--color-nz);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-right: 12px;
}

.header-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.avatar-initial {
    color: white;
    font-size: 18px;
    font-weight: 600;
}

.status-bubble-2 {
    position: absolute;
    bottom: 2px;
    right: 10px;
    width: 12px;
    height: 12px;
    border: 2px solid white;
    border-radius: 50%;
}

.status-bubble-2.online {
    background-color: var(--success-200);
}

.status-bubble-2.offline {
    background-color: var(--gray-400);
}

.header-info h2 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: var(--gray-900);
    display: flex;
    align-items: center;
    gap: 4px;
}

.header-info p {
    margin: 0;
    font-size: 12px;
    color: var(--gray-500);
}

.verified-icon {
    width: 16px;
    height: 16px;
    color: var(--success-400);
}

.more-button {
    background: none;
    border: none;
    padding: 8px;
    cursor: pointer;
}

.more-button svg {
    width: 20px;
    height: 20px;
    color: var(--gray-500);
}

@media (min-width: 768px) {
    .back-button {
        display: none;
    }

}

@media (max-width: 768px) {
    .conversation-header {
        padding: 0px;
    }
}
</style>